import { onAuthStateChanged } from "firebase/auth";

const fallbackAdminsFromEnv = (process.env.REACT_APP_ADMIN_EMAILS || "")
  .split(",")
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

const DEFAULT_FALLBACK_ADMINS = ["admin@gmail.com", "kunwarisha9@gmail.com"];

const isFallbackAdminEmail = (email = "") => {
  const target = email.toLowerCase();
  const source = fallbackAdminsFromEnv.length
    ? fallbackAdminsFromEnv
    : DEFAULT_FALLBACK_ADMINS;
  return source.includes(target);
};

const hasAdminClaim = async (user) => {
  if (!user) return false;
  try {
    const tokenResult = await user.getIdTokenResult();
    const claims = tokenResult?.claims || {};
    const hasClaim = Boolean(
      claims.admin || claims.isAdmin || claims.role === "admin"
    );
    if (hasClaim) return true;
    return isFallbackAdminEmail(user.email || "");
  } catch (error) {
    console.error("Failed to resolve admin claim:", error);
    return isFallbackAdminEmail(user.email || "");
  }
};

export const watchAdminStatus = (auth, callback) =>
  onAuthStateChanged(auth, async (user) => {
    const isAdmin = await hasAdminClaim(user);
    callback({ user, isAdmin });
  });
